import request from '../../config/apiConfig';
import { SocialFeedGlobalSettingsState } from './containers/SocialFeed/customize/SocialFeedContext';
import { GlobalSocialFeedSettings } from './types';

export const fetchChannelsByMarketer = (marketerId: string) => {
  return request.get(`channel/channels/marketer`, { params: { id: marketerId, sort: 'created,desc' } });
};

export const fetchStreamsByMarketer = () => {
  return request.get(`channel/streams/marketer`, { params: { sort: 'created,desc' } });
};

export const fetchPlacementsByMarketer = () => {
  return request.get(`channel/placements/marketer`, { params: { sort: 'created,desc' } });
};

export const fetchSuperfeedsByMarketer = () => {
  return request.get(`partner/superfeeds`, {});
};

export const createSuperfeedForMarketer = (data: {
  title: string;
  description: string;
  prefix: string;
  domain: string;
  logo?: string;
  favicon?: string;
}) => {
  return request.post(`partner/superfeeds`, data);
};

export const updateGlobalSuperfeedSettings = (superfeedId: string, settings: GlobalSocialFeedSettings) => {
  return request.put(`partner/superfeeds/${superfeedId}/settings/global`, settings);
};

export const updateGlobalMobileSuperfeedSettings = (superfeedId: string, settings: SocialFeedGlobalSettingsState) => {
  return request.put(`partner/superfeeds/${superfeedId}/settings/global/mobile`, settings);
};

export const createStreamForMarketer = (data: { channel: string; name: string; url: string }) => {
  return request.post(`channel/streams/marketer`, data, { params: { channel: data.channel } });
};

export const createPlacementForMarketer = (data: { name: string; channel: string; stream: string }) => {
  return request.post(`channel/placements/marketer`, data, { params: { channel: data.channel } });
};

export const updatePlacementForMarketer = (data: {
  placementId: string;
  marketerId: string;
  name: string;
  stream: string;
}) => {
  return request.put(`channel/placements/${data.placementId}/update`, data);
};

export const createPrefixForMarketer = (data: { marketerId: string; prefix: string }) => {
  return request.put(`partner/marketers/${data.marketerId}/prefix`, { prefix: data.prefix });
};

export const updatePlacementProperties = (feedId: string, properties: any) => {
  return request.put(`channel/placements/${feedId}/properties`, properties);
};

export const updatePlacementMobileProperties = (feedId: string, properties: any) => {
  return request.put(`channel/placements/${feedId}/properties/mobile`, properties);
};

export const updateSuperfeedFilterSettings = (superfeedId: string, settings: any) => {
  return request.put(`partner/superfeeds/${superfeedId}/settings/filter`, settings);
};

export const updateSuperfeedMobileFilterSettings = (superfeedId: string, settings: any) => {
  return request.put(`partner/superfeeds/${superfeedId}/settings/filter/mobile`, settings);
};

export const updateSuperfeedTitle = (payload: { id: string; title: string }) => {
  return request.put(`partner/superfeeds/${payload.id}/title`, { title: payload.title });
};

export const updateSuperfeedDescription = (payload: { id: string; description: string }) => {
  return request.put(`partner/superfeeds/${payload.id}/description`, { description: payload.description });
};

export const updateSuperfeedFavIcon = (payload: { id: string; favicon: string }) => {
  return request.put(`partner/superfeeds/${payload.id}/favicon`, { favicon: payload.favicon });
};

export const updateSuperfeedPreviewImage = (payload: { id: string; previewImage: string }) => {
  return request.put(`partner/superfeeds/${payload.id}/preview`, { preview: payload.previewImage });
};

export const updateSuperfeedPrefix = (payload: { id: string; prefix: string }) => {
  return request.put(`partner/superfeeds/${payload.id}/prefix`, { prefix: payload.prefix });
};

export const updateSuperfeedDomain = (payload: { id: string; domain: string }) => {
  return request.put(`partner/superfeeds/${payload.id}/domain`, { domain: payload.domain });
};

export const updateSuperfeedLogo = (payload: { id: string; logo: string }) => {
  return request.put(`partner/superfeeds/${payload.id}/logo`, { logo: payload.logo });
};

export const updateSuperfeedFavicon = (payload: { id: string; favicon: string }) => {
  return request.put(`partner/superfeeds/${payload.id}/favicon`, { favicon: payload.favicon });
};

export const updateStream = (streamId: string, data: { name: string; url?: string }) => {
  return request.put(`channel/streams/${streamId}/update`, data);
};

export const putMediaContent = (payload: FormData, id: string, category: string) => {
  return request.put(`content/assets/${category}/${id}`, payload);
};

export const fetchSocialFeedConfiguration = (id: string) => {
  return request.get(`/settings/api/v1/management/superfeed/${id}/config/`);
};

export const updateWebBannerConfiguration = (id: string, payload: any) => {
  return request.put(`/settings/api/v1/management/superfeed/${id}/config/banner/`, payload);
};

export const updateWebFeedPlayerConfiguration = (id: string, payload: any) => {
  return request.put(`/settings/api/v1/management/superfeed/${id}/config/feed/player/`, payload);
};
export const updateWebFeedShareConfiguration = (id: string, payload: any) => {
  return request.put(`/settings/api/v1/management/superfeed/${id}/config/feed/share/`, payload);
};
export const updateWebFeedCommentsConfiguration = (id: string, payload: any) => {
  return request.put(`/settings/api/v1/management/superfeed/${id}/config/feed/comment/`, payload);
};
export const updateWebNavigationHomeConfiguration = (id: string, payload: any) => {
  return request.put(`/settings/api/v1/management/superfeed/${id}/config/navigation/home/`, payload);
};
export const updateWebNavigationFeedConfiguration = (id: string, payload: any) => {
  return request.put(`/settings/api/v1/management/superfeed/${id}/config/navigation/feed/`, payload);
};
export const updateWebNavigationUserProfileConfiguration = (id: string, payload: any) => {
  return request.put(`/settings/api/v1/management/superfeed/${id}/config/navigation/user_profile/`, payload);
};
export const updateWebNavigationCourseConfiguration = (id: string, payload: any) => {
  return request.put(`/settings/api/v1/management/superfeed/${id}/config/navigation/course/`, payload);
};

export const updateMobileBannerConfiguration = (id: string, payload: any) => {
  return request.put(`/settings/api/v1/management/superfeed/${id}/config/mobile/banner/`, payload);
};
export const updateMobileFeedPlayerConfiguration = (id: string, payload: any) => {
  return request.put(`/settings/api/v1/management/superfeed/${id}/config/mobile/feed/player/`, payload);
};
export const updateMobileFeedShareConfiguration = (id: string, payload: any) => {
  return request.put(`/settings/api/v1/management/superfeed/${id}/config/mobile/feed/share/`, payload);
};
export const updateMobileFeedCommentsConfiguration = (id: string, payload: any) => {
  return request.put(`/settings/api/v1/management/superfeed/${id}/config/mobile/feed/comment/`, payload);
};
export const updateMobileNavigationHomeConfiguration = (id: string, payload: any) => {
  return request.put(`/settings/api/v1/management/superfeed/${id}/config/mobile/navigation/home/`, payload);
};
export const updateMobileNavigationFeedConfiguration = (id: string, payload: any) => {
  return request.put(`/settings/api/v1/management/superfeed/${id}/config/mobile/navigation/feed/`, payload);
};
export const updateMobileNavigationUserProfileConfiguration = (id: string, payload: any) => {
  return request.put(`/settings/api/v1/management/superfeed/${id}/config/mobile/navigation/user_profile/`, payload);
};
export const updateMobileNavigationCourseConfiguration = (id: string, payload: any) => {
  return request.put(`/settings/api/v1/management/superfeed/${id}/config/mobile/navigation/course/`, payload);
};
